import { render, staticRenderFns } from "./FollowupsDataCell.vue?vue&type=template&id=1d8515a8&scoped=true"
import script from "./FollowupsDataCell.vue?vue&type=script&lang=js"
export * from "./FollowupsDataCell.vue?vue&type=script&lang=js"
import style0 from "./FollowupsDataCell.vue?vue&type=style&index=0&id=1d8515a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8515a8",
  null
  
)

export default component.exports